export const load = () => ({
	h1: 'Save up to $1,200 on Thermal Window Inserts with Tax Credits.',
	title: 'Save $1,200 on Indow thermal window inserts with Tax Credits',
	description:
		'Save up to 30% on the cost of energy-saving Indow window inserts with tax credits from the Inflation Reduction Act. Lower your tax bill by purchasing energy-efficient window inserts and reduce your utility bills by 20%',
	showTitle: false,

	hideHeaderButton: false,
});
